// extracted by mini-css-extract-plugin
export default {"button_profile_info":"profileInfo_button_profile_info__ViP4f","button_user_image":"profileInfo_button_user_image__759vZ"};